"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_helmet_1 = tslib_1.__importDefault(require("react-helmet"));
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../context");
const reusables_1 = require("../reusables");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.AppLoaderIndicator = () => {
    const { loadApp } = react_1.useContext(context_1.OsmosysAppContext);
    const [retrying, toggleRetry] = react_2.useTimedToggle(500);
    const { refetch, loading, error } = loadApp || {
        error: false,
        loading: true,
        refetch: () => { },
    };
    const loadingMessage = retrying
        ? 'Retrying...'
        : loading
            ? 'Connecting to Osmosys...'
            : error
                ? 'Could not connect to Osmosys'
                : 'Welcome to Osmosys';
    const disabled = loading || retrying;
    return (react_1.default.createElement(reactstrap_1.Fade, { in: true, className: "flex-full-col-centered", tag: react_2.OsmosysDiv, osysName: "AppLoaderIndicator" },
        react_1.default.createElement("div", { className: "flex-full-col-centered" },
            react_1.default.createElement(react_helmet_1.default, { title: loadingMessage }),
            react_1.default.createElement(reusables_1.Loading, { useLogo: true, useContainer: true, message: loadingMessage },
                react_1.default.createElement(react_if_1.When, { condition: !!error },
                    react_1.default.createElement(react_2.OsmosysButton, { className: "mt-2", osysName: "ReloadApp", size: "sm", osysIcon: "reload", disabled: disabled, iconSpin: loading || retrying, onClick: () => {
                            toggleRetry();
                            refetch();
                        } }, "Retry"))))));
};
//# sourceMappingURL=AppLoaderIndicator.js.map